import DtoHydroSituationDayMeasure from './DtoHydroSituationDayMeasure'

export default class DtoHydroSituationDays {
    constructor(obj) {
        this.hydroId = obj.hydroId
        this.days = obj.days.map(d => new DtoHydroSituationDayMeasure(d))
    }
}